import React from 'react';
import { Typography, Button } from '@mui/material';
import sendToNotifier from '~/_base/functions/errorNotifiers';

interface State {
  error: any;
  errorInfo: any;
}

interface Props {
  context: any;
  retry: () => void;
  goHome: () => void;
  children?: React.ReactNode;
}

export default class ErrorBoundary extends React.Component<Props, State> {
  constructor(props: Props) {
    super(props);
    this.state = { error: null, errorInfo: null };
  }

  componentDidCatch(error: any, errorInfo: any) {
    this.setState({
      error: error,
      errorInfo: errorInfo,
    });
    sendToNotifier('frontend: ' + error, errorInfo, this.props.context);
  }

  handleGoHome() {
    this.setState({
      error: null,
      errorInfo: null,
    });
    this.props.goHome();
  }

  handleRetry() {
    this.setState({
      error: null,
      errorInfo: null,
    });
    this.props.retry();
  }

  render() {
    if (this.state.errorInfo != null) {
      return (
        <div
          style={{
            padding: 24,
            border: '1px solid #e7c0bc',
            borderRadius: 4,
            backgroundColor: '#fdf6f5',
          }}
        >
          <Typography variant="h1">Oops!</Typography>
          <Typography variant="h4" style={{ margin: '16px 0px' }}>
            An error occured loading a component.
          </Typography>
          <Button onClick={() => this.handleGoHome()} variant="contained" color="secondary">
            Go Home
          </Button>
          <Button
            variant="contained"
            color="secondary"
            onClick={() => this.handleRetry()}
            style={{ marginLeft: 8 }}
          >
            Retry
          </Button>
        </div>
      );
    }
    // Normally, just render children
    return this.props.children;
  }
}
